import { createSelector } from 'reselect';
import pipe from 'ramda/es/pipe';
import toPairs from 'ramda/es/toPairs';
import values from 'ramda/es/values';
import any from 'ramda/es/any';
import filter from 'ramda/es/filter';
import map from 'ramda/es/map';
import join from 'ramda/es/join';
import replace from 'ramda/es/replace';

import { USER_TYPE_PARENT } from 'app/common/constants/users';
import selectRestrictions from 'app/common/components/Profile/selectRestrictions';
import getRegAvailable from 'app/selectors/getRegAvailable';


const isAnyInObj = pipe(values, any(b => b));
const services = {
  fio: 'ФИО',
  phone: 'телефон',
  email: 'e-mail',
  password: 'пароль',
};


export const selectIsProfileDelAvalable = createSelector(
  [
    state => state.user.type,
    getRegAvailable,
  ],
  (userType, regAvailable) => (userType === USER_TYPE_PARENT && regAvailable)
);

const selectIntroText = createSelector(
  [
    selectIsProfileDelAvalable,
    selectRestrictions,
    (_, { t }) => t,
  ],
  (deleteProfile, others, t) => {
    const isAnyOfOthers = isAnyInObj(others);
    if (!deleteProfile && !isAnyOfOthers) {
      return '';
    }

    if (deleteProfile && !isAnyOfOthers) {
      return t('profile_intro_only_delete');
    }

    const activeServices = pipe(
      toPairs,
      filter(([_, val]) => val), // eslint-disable-line no-unused-vars
      map(([key]) => services[key]),
      join(', '),
      replace(/,\s([^,]*)$/g, ` ${t('services_last_delimiter')} $1`)
    )(others);

    return (deleteProfile
      ? t('profile_intro_chage_n_delete', { activeServices })
      : t('profile_intro_chage', { activeServices }));
  }
);

export default selectIntroText;
